import React, { useState, useEffect } from "react";
import axios from "axios";
import Constant from "../Constant";
import { Modal } from "react-bootstrap";
import { getAccessToken } from "../../hooks/AccessToken";

const EditAppVersionModal = ({
  open,
  onClose,
  appVersion,
  onAppVersionUpdated,
  showNotification,
}) => {
  const [versionNo, setversionNo] = useState("");
  const [forceUpdate, setForceUpdate] = useState(false);

  // Initialize form with existing data when modal opens
  useEffect(() => {
    if (appVersion) {
      setversionNo(appVersion.versionNo);
      setForceUpdate(appVersion.forceUpdate);
    }
  }, [appVersion]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!versionNo) {
      showNotification("Version Number is required", "error");
      return;
    }

    try {
      let token = getAccessToken();
      const response = await axios.patch(
        `${Constant.apiBasePath}appVersion/edit/${appVersion._id}`,
        {
          versionNo,
          forceUpdate,
          platform: appVersion.platform,
        },
        { headers: { token: token } }
      );

      showNotification("App Version updated successfully");
      onAppVersionUpdated();
      onClose();
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to update app version";
      showNotification(errorMessage, "error");
      console.error("Error updating app version:", error);
    }
  };

  return (
    <Modal show={open} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit {appVersion?.platform} App Version</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="platform" className="form-label">
              Platform
            </label>
            <input
              type="text"
              className="form-control"
              id="platform"
              value={appVersion?.platform}
              disabled
            />
          </div>

          <div className="mb-3">
            <label htmlFor="versionNo" className="form-label">
              Version Number
            </label>
            <input
              type="text"
              className="form-control"
              id="versionNo"
              value={versionNo}
              onChange={(e) => setversionNo(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Force Update</label>
            <div className="d-flex">
              <div className="form-check me-3 mr-2">
                <input
                  type="radio"
                  className="form-check-input"
                  id="forceUpdateYes"
                  name="forceUpdate"
                  checked={forceUpdate === true}
                  onChange={() => setForceUpdate(true)}
                  required
                />
                <label className="form-check-label" htmlFor="forceUpdateYes">
                  Yes
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  className="form-check-input"
                  id="forceUpdateNo"
                  name="forceUpdate"
                  checked={forceUpdate === false}
                  onChange={() => setForceUpdate(false)}
                  required
                />
                <label className="form-check-label" htmlFor="forceUpdateNo">
                  No
                </label>
              </div>
            </div>
          </div>

          <div className="text-end">
            <button
              type="button"
              className="btn btn-secondary me-2 mr-2"
              onClick={onClose}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              Update
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default EditAppVersionModal;
